import { render } from "./DialogSuccess.vue?vue&type=template&id=60e84a19"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"

import "./DialogSuccess.vue?vue&type=style&index=0&id=60e84a19&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__